import * as metricFormatter from '@bingads-webui-campaign-legacy/performance-metric-formatter/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';

export const tableDeps = {
  metricFormatter,
  dateUtil,
  jsdata,
};

